import React from 'react';

import  Fittinginjctio from './Fittinginjctio';
import Fitticorros from './Fitticorros';
import Specialiproc from './Specialiproc';
import Grafiplaten from './Grafiplaten';



const Petperforminje = () => {
  return (
    <div>
       <Fittinginjctio/>
      <Fitticorros/>
      <Specialiproc/>
      <Grafiplaten/>
    </div>
  );
};

export default Petperforminje;
